module.exports = __webpack_public_path__ + "img/赵老师-1.982b5365.png";